module.exports = __webpack_public_path__ + "static/media/course-placeholder-no-padding.9dd7d624.svg";